import { AddableModuleType } from "@formant/core/model/AddableModuleType";
import { IComment } from "@formant/core/model/IComment";
import { IDevice } from "@formant/core/model/IDevice";
import { IEvent } from "@formant/core/model/IEvent";
import { IFilter } from "@formant/core/model/IFilter";
import { ILayoutModule } from "@formant/core/model/ILayoutModule";
import { IPartialViewConfiguration } from "@formant/core/model/IPartialViewConfiguration";
import { IShare } from "@formant/core/model/IShare";
import { IViewConfiguration } from "@formant/core/model/IViewConfiguration";
import { ModuleMode } from "@formant/core/model/ModuleMode";

export interface IBaseModuleProps {
    streamName: string;
    streamNames: string[];
    streamType: AddableModuleType;
    device?: IDevice;
    filter: IFilter;
    loading?: boolean;
    focused?: boolean;
    fullscreen?: boolean;
    hovering?: boolean;
    editingLayout?: boolean;
    activeEvent?: IEvent;
    configurationDisabled?: boolean;
    configuration: IViewConfiguration[];
    teleop: boolean;
    onSelectTime?: (time: Date) => void;
    onFocus: () => void;
    onBlur: () => void;
    onToggleFullscreen: () => void;
    onClose?: () => void;
    onConfigure?: () => void;
    onChangeConfiguration?: (value: IPartialViewConfiguration) => void;
    onComment?: (comment: Partial<IComment>) => void;
    hideDevice: boolean;
    share?: IShare;
    layoutModule?: ILayoutModule;
    onConfigureModule?: (moduleName: string) => void;
    onRemoveModule?: (moduleName: string) => void;
    nonInteractable?: boolean;
    moduleMode: ModuleMode;
}
